import templateUrl from 'emun.salesrep/territory-manager/repassignment/repassignment-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import AssignmentPrompt from "emun.salesrep/territory-manager/repassignment/repassignment-prompt"

class RepAssignmentListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QueryRepAssignments.json',
			autoLoad: true,
			hideLeftNav: true,
			filters: [ 
			{ groupBy: "isCompleted", title: "Completed", collapsed: true },
			{ groupBy: "CurrentRepName", title: "Orginal Rep", collapsed: true },
			{ groupBy: "SalesRepName", title: "New Rep", collapsed: true } ]
		});
		let $rootScope = resolve("$rootScope");
		$rootScope.$on("repassignmentSaved", () => $ctrl.query.load(true));
    }
	create() {
		const $ctrl = this;
		AssignmentPrompt.open({ assignment: "", assignmentId: "" });
	}

	edit(assignment) {
		const $ctrl = this;
		AssignmentPrompt.open({ assignment: assignment, assignmentId: assignment.id });
	}

	delete(assignment) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete this assignment", "Delete Rep Assignment?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteRepAssignment.json", assignment)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
}

let RepAssignmentList = {
	controller: RepAssignmentListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default RepAssignmentList;
